import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import styled from "styled-components";

interface CartGroupProps {
    withNoTitle?: boolean;
}

export const CartGroup = styled.div<CartGroupProps>(({ theme, withNoTitle }) => ({
    backgroundColor: theme.colors[theme.colorMode].background_Primary,
    margin: `0 ${theme.spacing.medium}`,
    boxShadow: "none",
    borderRadius: theme.cornerRadius.medium,
    padding: withNoTitle
        ? `${theme.spacing.medium} ${theme.spacing.medium} ${theme.spacing.large} ${theme.spacing.medium}`
        : `${theme.spacing.large} ${theme.spacing.medium}`,
    overflow: "hidden",
}));

export const CartGroupHeader = styled.div(({ theme }) => ({
    padding: `0 ${theme.spacing.large}`,
    marginBottom: theme.spacing.medium,
}));

export const CartGroupHeaderTitle = styled(Text)(({ theme }) => ({
    color: theme.colors[theme.colorMode].text_High_Emphasis,
    margin: 0,
}));
